import { evenementVersStatutTache, STATUTS_TACHE } from '@admin-pmvb/core'
import type { Tache } from '../api'
import { LIBELLES_STATUT_TACHE } from '../libelles'
import { Icone } from './Icone'
import { type EvenementTache, ICONES_STATUT_TACHE } from './LigneTache'

type Statut = Tache['statut']

/**
 * Les cinq statuts d'une tâche en pastilles : l'actuel en couleur, un toucher sur un autre
 * y mène par l'événement de la machine d'états ; ceux qu'on ne peut pas atteindre d'ici
 * (retour de « en cours » à « à faire », d'un statut fermé à l'autre) sont grisés.
 */
export function ChoixStatutTache({
  statut,
  onChoisir,
  lectureSeule = false,
  occupe = false,
}: {
  statut: Statut
  onChoisir: (evenement: EvenementTache, vers: Statut) => void
  lectureSeule?: boolean
  occupe?: boolean
}) {
  return (
    <div className="choix-statut" role="group" aria-label="Statut de la tâche">
      {STATUTS_TACHE.map((s) => {
        const evenement = evenementVersStatutTache(statut, s)
        const actuel = s === statut
        return (
          <button
            key={s}
            type="button"
            className={`choix-statut-option statut-${s}${actuel ? ' actuel' : ''}`}
            aria-pressed={actuel}
            disabled={actuel || lectureSeule || occupe || evenement === null}
            title={
              actuel || lectureSeule || evenement ? undefined : 'Pas directement depuis ce statut'
            }
            onClick={() => evenement && onChoisir(evenement, s)}
          >
            <Icone nom={ICONES_STATUT_TACHE[s]} plein={actuel} />
            <span>{s === 'en_attente_tiers' ? 'En attente' : LIBELLES_STATUT_TACHE[s]}</span>
          </button>
        )
      })}
    </div>
  )
}
